import React from "react";
 
const IframeMessage = props => {
  return (
<div id="" class="">
	<div class="">
		<h3>Network Problem</h3>
		{/* <a class="close hand" onClick={props.handle_message}>&times;</a> */}
		<div class="text-center mt-2">
		Unable to add a new card please try again later.
   </div>
		<div class="text-center mt-2">
		<button type="button" class="btn close_btn size_12 font_fam mt-4" onClick={props.handle_reload_btn}>Try again </button>
		</div>
	</div>
</div>
  );
};
 
export default IframeMessage;